const PTHealth = [
    {
        title: '"A janela está a fechar-se". Secretário da Saúde dos EUA preocupado com o avanço da pandemia',
        description: 'No momento em que o número total de infetados nos EUA ultrapassa os 2,5 milhões, o secretário da Saúde dos EUA, Alex Azar, alerta que o país está numa corrida contra o tempo para conter o avanço da pandemia.',
        url: 'https://www.rtp.pt/noticias/mundo/a-janela-esta-a-fechar-se-secretario-da-saude-dos-eua-preocupado-com-o-avanco-da-pandemia_n1241009',
        image: 'https://cdn-images.rtp.pt/icm/noticias/images/2e/2e015f772a1954ae769b3b25a75cb8a9?w=860&q=90&rect=0,54,1303,714&auto=format',
        publishedAt: "2020-06-29T17:30:00Z",
        source: {
            name: 'RTP',
            url: 'https://www.rtp.pt'
        }
    },
    {
        title: 'José de Mello Saúde passa a usar CUF como marca única',
        description: 'O Grupo José de Mello desenvolve a sua atividade através da rede nacional de 18 hospitais e clínicas e de um hospital gerido em parceria público-privada [PPP].',
        url: 'https://jornaleconomico.sapo.pt/noticias/jose-de-mello-saude-passa-a-usar-cuf-como-marca-unica-606856',
        image: 'https://jornaleconomico.sapo.pt/wp-content/uploads/2018/08/cuf-porto.jpg?w=730&h=456&q=60&compress=auto,format&fit=crop',
        publishedAt: "2020-06-28T18:10:00Z",
        source: {
            name: 'Jornal Económico',
            url: 'https://jornaleconomico.sapo.pt'
        }
    },
    {
        title: 'Autoridades de saúde admitem desafios em Lisboa: “Temos uma enorme dificuldade em pronunciar o nome das pessoas, uma enorme dificuldade em comunicar”',
        description: 'O coordenador do gabinete de crise para Lisboa e Vale do Tejo apontou que a grande Lisboa tem “características muito específicas: alta densidade populacional e uma enorme diversificação da população”.',
        url: 'https://jornaleconomico.sapo.pt/noticias/autoridades-de-saude-admitem-desafios-na-comunicacao-com-a-populacao-em-lisboa-temos-uma-enorme-dificuldade-em-pronunciar-o-nome-das-pessoas-uma-enorme-dificuldade-em-comunicar-606786',
        image: 'https://jornaleconomico.sapo.pt/wp-content/uploads/2020/03/Covid-19-rastreio.jpg?w=730&h=456&q=60&compress=auto,format&fit=crop',
        publishedAt: "2020-06-30T11:40:00Z",
        source: {
            name: 'Jornal Económico',
            url: 'https://jornaleconomico.sapo.pt'
        }
    },
    {
        title: 'Casos de violência contra profissionais de saúde atingem recordes: mais 1300 só no ano passado',
        description: 'A Direcção-Geral da Saúde (DGS) recebeu um total de 1.355 notificações de incidentes de violência contra profissionais de saúde em 2019. As notigicações são registadas na plataforma da DGS, um sistema que foi criado em 2006 e que desde então acumulou 5.611 casos de violência.',
        url: 'https://executivedigest.sapo.pt/casos-de-violencia-contra-profissionais-de-saude-atingem-recordes-mais-1300-so-no-ano-passado/',
        image: 'https://executivedigest.sapo.pt/wp-content/uploads/2019/11/medico.jpg',
        publishedAt: "2020-06-27T08:30:00Z",
        source: {
            name: 'Executive Digest',
            url: 'https://executivedigest.sapo.pt'
        }
    },
    {
        title: 'Ministra da Saúde tranquiliza em relação ao IPO, depois dos casos em Monchique',
        description: 'A ministra da Saúde tranquilizou hoje os utentes do Instituto Português de Oncologia (IPO) de Lisboa, depois das situações de doentes de outras regiões infetados com Covid-19 nessa unidade hospitalar, nomeadamente uma senhora de Monchique, que acabou por contagiar cinco familiares seus.',
        url: 'https://www.sulinformacao.pt/2020/06/ministra-da-saude-tranquiliza-em-relacao-ao-ipo-depois-dos-casos-em-monchique/',
        image: 'https://www.dinheirovivo.pt/wp-content/uploads/2018/10/marta-temido-1060x594.jpg',
        publishedAt: "2020-06-27T12:30:00Z",
        source: {
            name: 'Sul Informação',
            url: 'https://www.sulinformacao.pt'
        }
    },
    {
        title: 'Férias de profissionais de saúde de Évora suspensas até 10 de julho',
        description: 'As férias dos profissionais que prestam cuidados diretos de saúde do Agrupamento de Centros de Saúde do Alentejo Central estão suspensas até 10 de julho, numa tentativa de travar o surto de covid-19 em Reguengos de Monsaraz.',
        url: 'https://www.jn.pt/local/noticias/evora/evora/ferias-de-profissionais-de-saude-de-evora-suspensas-ate-10-de-julho-12362915.html',
        image: 'https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=8f25bf7f-4e7a-4970-86d6-e38244a98e27&w=744&h=495&t=20200628140409',
        publishedAt: "2020-06-29T17:30:00Z",
        source: {
            name: 'Jornal de Notícias',
            url: 'https://www.jn.pt'
        }
    },
    {
        title: 'Alcácer do Sal investe 100 mil euros em nova extensão de Saúde de Palma',
        description: 'Nova unidade irá abranger uma população de 300 utentes, na maioria idosos, mas também pessoas que trabalham e carecem de cuidados de saúde devido à distância do centro de saúde de Alcácer do Sal.',
        url: 'https://observador.pt/2020/06/24/alcacer-do-sal-investe-100-mil-euros-em-nova-extensao-de-saude-de-palma/',
        image: 'https://bordalo.observador.pt/900x,q85/https://s3.observador.pt/wp-content/uploads/2020/06/24143853/gettyimages-590665423-scaled_770x433_acf_cropped.jpg',
        publishedAt: "2020-06-29T17:30:00Z",
        source: {
            name: 'Observador',
            url: 'https://observador.pt'
        }
    },
    {
        title: 'Novo Orçamento de Cabo Verde aposta na saúde e parceria com privados',
        description: 'O Governo cabo-verdiano prevê 31,6 milhões de euros para reforçar o Sistema Nacional de Saúde, através do Orçamento do Estado Retificativo para 2020, numa aposta que passa também por parcerias público-privadas para serviços de saúde.',
        url: 'https://www.rtp.pt/noticias/mundo/novo-orcamento-de-cabo-verde-aposta-na-saude-e-parceria-com-privados_n1240065',
        image: 'https://cdn-images.rtp.pt/icm/noticias/images/b9/b97b1ce0337414eb7fc95f1758bb6687?w=860&q=90&rect=0,5,770,422&auto=format',
        publishedAt: "2020-06-25T19:50:00Z",
        source: {
            name: 'RTP',
            url: 'https://www.rtp.pt'
        }
    },
    {
        title: '"Inaceitável". Liverpool critica festejos dos adeptos e lembra risco na saúde pública',
        description: 'O Liverpool considerou hoje "inaceitável" o comportamento dos adeptos, que se juntaram na sexta-feira no Pier Head (zona portuária) para festejar a conquista da Liga inglesa de futebol, depois de sucessivos alertas em relação ao perigo da covid-19.',
        url: 'https://www.dn.pt/desportos/inaceitavel-liverpool-critica-festejos-dos-adeptos-e-lembra-risco-na-saude-publica-12360633.html',
        image: 'https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=84f86e3b-90f1-4294-96e6-ccdab77e935f&w=800&h=450&t=20200627112510',
        publishedAt: "2020-06-21T09:10:00Z",
        source: {
            name: 'Diário de Notícias',
            url: 'https://www.dn.pt'
        }
    },
    {
        title: 'Holanda atribui prémio de mil euros a profissionais de saúde',
        description: 'Os trabalhadores do setor da saúde holandês, como enfermeiros, auxiliares e pessoal da limpeza, vão receber um bónus de 1.000 euros líquidos pelo esforço adicional durante a pandemia de covid-19, anunciou esta quinta-feira o ministro da Saúde.',
        url: 'https://sicnoticias.pt/especiais/coronavirus/2020-06-25-Holanda-atribui-premio-de-mil-euros-a-profissionais-de-saude',
        image: 'https://images.impresa.pt/sicnot/2020-06-19-RTS38IZT.JPG-1/original/mw-860',
        publishedAt: "2020-06-29T17:40:00Z",
        source: {
            name: 'SIC Notícias',
            url: 'https://sicnoticias.pt'
        }
    },
    {
        title: 'Prémio de Inovação em Saúde da U.Porto distingue 4 projetos de "combate" ao vírus',
        description: 'Revestimento para tornar superfícies antivirais, dispositivo para monitorizar tosse, terapia contra a inflamação descontrolada e desenvolvimento de anticorpos neutralizantes foram soluções premiadas.',
        url: 'https://observador.pt/2020/06/22/premio-de-inovacao-em-saude-da-u-porto-distingue-4-projetos-de-combate-ao-virus/',
        image: 'https://bordalo.observador.pt/900x,q85/https://s3.observador.pt/wp-content/uploads/2020/06/22111326/reitoria_da_universidade_do_porto_portugal_00111453e8c_770x433_acf_cropped-1.jpg',
        publishedAt: "2020-06-28T13:10:00Z",
        source: {
            name: 'Observador',
            url: 'https://observador.pt'
        }
    },
    {
        title: 'Startup de saúde portuguesa chega a quatro países europeus, exportações representam 25% das receitas',
        description: 'Startup criada para superar o desafio da demora das atualizações no campo da saúde e apresentar as melhores práticas clínicas já fechou contratos na Grécia, Noruega, Países Baixos e Suécia.',
        url: 'https://observador.pt/2020/06/16/startup-de-saude-portuguesa-chega-a-quatro-paises-europeus-exportacoes-representam-25-das-receitas/',
        image: 'https://bordalo.observador.pt/900x,q85/https://s3.observador.pt/wp-content/uploads/2020/06/16131552/uphillmeetinghd-237_770x433_acf_cropped.jpg',
        publishedAt: "2020-06-27T11:20:00Z",
        source: {
            name: 'Observador',
            url: 'https://observador.pt'
        }
    },
    {
        title: 'Autoridades de Nova Deli assumem escassez de profissionais de saúde',
        description: 'A cidade de Nova Deli está a enfrentar uma escassez de profissionais de saúde “treinados e experientes” face à pandemia de covid-19, reconheceu este sábado o ministro da Saúde em exercício do governo da capital da Índia.',
        url: 'https://www.acorianooriental.pt/noticia/covid-19-autoridades-de-nova-deli-assumem-escassez-de-profissionais-de-saude-313938',
        image: 'https://www.acorianooriental.pt/images/articleframe_hd/42842.jpg',
        publishedAt: "2020-06-29T17:30:00Z",
        source: {
            name: 'Açoriano Oriental',
            url: 'https://www.acorianooriental.pt'
        }
    },
    {
        title: 'Governo dos EUA quer terminar plano de saúde apesar da pandemia',
        description: 'O Governo de Donald Trump pediu ao Supremo Tribunal para anular a lei de assistência médica, numa semana em que aumentam os casos de coronavírus em mais de metade dos estados dos EUA.',
        url: 'https://www.noticiasaominuto.com/mundo/1517410/governo-dos-eua-quer-terminar-plano-de-saude-apesar-da-pandemia',
        image: 'https://media-manager.noticiasaominuto.com/1920/1593176903/naom_5e7938d90c8a8.jpg?crop_params=eyJsYW5kc2NhcGUiOnsiY3JvcFdpZHRoIjoyNTYwLCJjcm9wSGVpZ2h0IjoxNDM5LCJjcm9wWCI6MCwiY3JvcFkiOjI1OH19',
        publishedAt: "2020-06-21T21:10:00Z",
        source: {
            name: 'Notícias ao Minuto',
            url: 'https://www.noticiasaominuto.com'
        }
    },
    {
        title: 'Saúde Mental. "Foi difícil pedir ajuda porque eu não sabia que podia ser ajudada"',
        description: 'Ana Gomes batalhou contra uma grande depressão. António Raminhos lida desde criança com um transtorno obsessivo-compulsivo, um transtorno de ansiedade. Recorrer a ajuda psicológica e psiquiátrica foi o início dos dois processos de recuperação.',
        url: 'https://magg.sapo.pt/saude/artigos/saude-mental-foi-dificil-pedir-ajuda-porque-eu-nao-sabia-que-podia-ser-ajudada',
        image: 'https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=ZTI3XG51+eQtYLzuAdud56P+n0oT3eD87ft6EnuL4u4O7Lb3e3NQ6ATv33azvwATo4Dh875Rd05EgAUOu9GvlrcL74VgzZUzCojsciEqQnkHZm0=',
        publishedAt: "2020-06-19T15:40:00Z",
        source: {
            name: 'Magg',
            url: 'https://magg.sapo.pt'
        }
    },
    {
        title: 'Novo Centro de Saúde de Algueirão Mem Martins ganha forma e dignidade',
        description: 'Basílio Horta visitou as obras de construção do novo Centro de Saúde de Algueirão Mem Martins, na antiga fábrica da Messa, irá distribuir-se por quatro unidades composta por 32 gabinetes de consulta médica e 20 gabinetes de enfermagem e tratamento.',
        url: 'https://sintranoticias.pt/2020/06/26/novo-centro-de-saude-de-algueirao-mem-martins-ganha-forma-e-dignidade/',
        image: 'https://sintranoticias.pt/wp-content/uploads/2020/06/centro-saude-amm2.jpg',
        publishedAt: "2020-06-29T11:10:00Z",
        source: {
            name: 'Sintra Notícias',
            url: 'https://sintranoticias.pt'
        }
    },
    {
        title: 'É preciso má-fé para transformar agradecimento à saúde em insulto — Costa',
        description: 'Para o primeiro-ministro, foi um agradecimento, e não um insulto, as palavras que dirigiu aos profissionais de saúde que permitiram que Portugal fosse referenciado como seguro.',
        url: 'https://visao.sapo.pt/atualidade/politica/2020-06-20-covid-19-e-preciso-ma-fe-para-transformar-agradecimento-a-saude-em-insulto-costa/',
        image: 'https://images.trustinnews.pt/uploads/sites/5/2020/06/29044468-1600x1067.jpg',
        publishedAt: "2020-06-27T12:40:00Z",
        source: {
            name: 'Visão',
            url: 'https://visao.sapo.pt'
        }
    },
    {
        title: 'Papa agradece a profissionais de saúde, a quem chama de "anjos"',
        description: 'O Papa Francisco agradeceu hoje o trabalho dos profissionais de saúde durante a pandemia e classificou-os de "anjos" para os doentes, no decorrer de uma receção a estes trabalhadores da região de Lombardia, a mais afetada pelo coronavírus.',
        url: 'https://www.noticiasaominuto.com/mundo/1513030/papa-agradece-a-profissionais-de-saude-a-quem-chama-de-anjos',
        image: 'https://media-manager.noticiasaominuto.com/1920/1592660417/29049592.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjk2MCwiY3JvcEhlaWdodCI6MTcwNywiY3JvcFgiOjQ4LCJjcm9wWSI6MH0sImxhbmRzY2FwZSI6eyJjcm9wV2lkdGgiOjAsImNyb3BIZWlnaHQiOjAsImNyb3BYIjowLCJjcm9wWSI6MH19',
        publishedAt: "2020-06-28T14:30:00Z",
        source: {
            name: 'Notícias ao Minuto',
            url: 'https://www.noticiasaominuto.com'
        }
    },
    {
        title: 'Médicos contra Costa: "o futebol não é um prémio para a saúde"',
        description: 'O bastonário da Ordem dos Médicos, Miguel Guimarães, não gostou de ouvir o primeiro-ministro, António Costa, dizer que a realização da final da Champions em Portugal é "um prémio" para os profissionais de saúde.',
        url: 'https://www.jn.pt/nacional/medicos-contra-costa-o-futebol-nao-e-um-premio-para-a-saude-12329507.html',
        image: 'https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=205d55be-7fc0-4b8f-b894-df8219aacd1b&w=744&h=495&t=20200619120958',
        publishedAt: "2020-06-26T11:20:00Z",
        source: {
            name: 'Jornal de Notícias',
            url: 'https://www.jn.pt'
        }
    },
    {
        title: 'Vhils faz homenagem a profissionais de saúde no Hospital de S. João. Obra estará concluída esta semana',
        description: 'O artista português Alexandre Farto, conhecido por Vhils, está a desenvolver uma homenagem os profissionais de saúde numa parede do Hospital de S. João, no Porto. Obra ficará pronta esta semana.',
        url: 'https://observador.pt/2020/06/15/vhils-faz-homenagem-a-profissionais-de-saude-no-hospital-de-s-joao-obra-estara-concluida-esta-semana/',
        image: 'https://bordalo.observador.pt/900x,q85/https://s3.observador.pt/wp-content/uploads/2020/06/15111813/103910850_3646439242039086_9210346712234258158_n_770x433_acf_cropped.jpg',
        publishedAt: "2020-06-26T11:20:00Z",
        source: {
            name: 'Observador',
            url: 'https://www.observador.pt'
        }
    }
]

export default PTHealth;
